export const HONDA_FACILITY_PARAM_KEYS = [
  ['Paint Shop', 'Pits'],
  ['Paint Shop', 'Boxes'],
  ['Body Repair', 'Pits'],
  ['Body Repair', 'Frame'],
  ['Service', 'Pits'],
  ['Service', 'Lifts'],
  ['Stock', 'Area'],
  ['Stock', 'Items'],
] as const;
